import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import FixFlowStep from './FixFlowStep'

class DatesStep extends FixFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.fix.steps.dates.title'),
      component,
      i18n.t('contract_versions.flows.fix.steps.dates.description')
    )
  }
}

export default DatesStep
